import auth from '@/store/modules/auth'
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	if (!to.userName || !to.password || !to.centerId) {
		if (to.name !== 'login' && !auth.state.authenticated) {
			next({ name: 'login', query: to.query, replace: true });
		} else if (to.name === 'login' && auth.state.authenticated) {
			next({ name: 'home' });
		} else {
			next();
		}
	} else {
		next();
	}
})

export default router